var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _vm.onlyOneChild.resourceName
                  ? _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.openIframe(_vm.item)
                          }
                        }
                      },
                      [
                        _c(
                          "el-menu-item",
                          {
                            class: { "submenu-title-noDropdown": !_vm.isNest },
                            attrs: { index: _vm.item.resourceId }
                          },
                          [
                            _c("item", {
                              attrs: {
                                icon: _vm.onlyOneChild.icon,
                                title: _vm.item.resourceName,
                                ismenu: _vm.item.parentResourceId == 0,
                                isMenuTitle: _vm.onlyOneChild.isMenuTitle
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: {
                    "popper-append-to-body": "",
                    index: _vm.item.resourceId
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.resourceName
                        ? _c("item", {
                            attrs: {
                              ismenu: _vm.item.parentResourceId == 0,
                              icon: _vm.item.icon,
                              title: _vm.item.resourceName
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._l(_vm.item.children, function(child) {
                    return _c("sidebar-item", {
                      key: child.resourceName,
                      staticClass: "nest-menu",
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": _vm.resolvePath(child.path)
                      }
                    })
                  })
                ],
                2
              )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }